import { render, staticRenderFns } from "./system.vue?vue&type=template&id=55d9bc5b&"
import script from "./system.vue?vue&type=script&lang=js&"
export * from "./system.vue?vue&type=script&lang=js&"
import style0 from "./system.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/admin_admin-web_uLO7/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('55d9bc5b')) {
      api.createRecord('55d9bc5b', component.options)
    } else {
      api.reload('55d9bc5b', component.options)
    }
    module.hot.accept("./system.vue?vue&type=template&id=55d9bc5b&", function () {
      api.rerender('55d9bc5b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/systemTools/system/system.vue"
export default component.exports